import '@/assets/css/reset.min.css'
import VueBus from 'vue-bus'
import { setCookie } from "@/utils/index";
import VueClipboard from 'vue-clipboard2'
import priceDecimal from '@/utils/priceDecimal.js'
const initMainCfg = (Vue, router) => {
    Number.prototype.az = function (n = 2) {
        let s = "";
        for (let i = 1; i < n; i++) {
            s += "0";
        }
        return (s + this).slice(-1 * n);
    };
    Vue.use(VueBus)
    Vue.use(VueClipboard)
    // 忽略自定义元素标签抛出的报错
    Vue.config.ignoredElements = [
        'wx-open-launch-app',
        'wx-open-launch-weapp'
    ];
    Vue.config.productionTip = false
    Vue.directive('price', priceDecimal)
    router.beforeEach((to, from, next) => {
        /* 路由发生变化修改页面title */
        const token = from.query["access_token"];
        const userId = from.query["userId"];
        if (token) {
            setCookie("token", token, 365 * 24 * 60 * 60);
        }
        if (userId) {
            setCookie("userId", userId, 365 * 24 * 60 * 60);
        }
        if (to.meta.title) {
            document.title = to.meta.title
        }
        next()
    })
    router.afterEach((to, from) => {
        const u = navigator.userAgent.toLowerCase()
        if (u.indexOf("like mac os x") < 0 || u.match(/MicroMessenger/i) !== 'micromessenger') return
        if (to.path !== location.pathname) {
            location.assign(to.fullPath)
        }
    })
}
export { initMainCfg }